/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import React from "react";

interface candidateProps {
  candidateFirstName: string;
  candidateLastName: string;
  headingText?: string;
}

export const ReferenceHistoryHeader: React.FC<candidateProps> = (
  props: candidateProps
) => {
  const { candidateFirstName, candidateLastName, headingText } = props;
  return (
    <div>
      <h3
        className={"ms-ac-referenceview-app-history-main-headingH3"}
        tabIndex={0}
      >
        <span data-testid={"data-heading-text"}>{headingText}</span>
        <span data-testid={"data-firstname-text"}> {candidateFirstName}</span>
        <span data-testid={"data-lastname-text"}> {candidateLastName}</span>
      </h3>
    </div>
  );
};
